import { render } from "./MetodePenyampaianForm.vue?vue&type=template&id=8c1d93aa"
import script from "./MetodePenyampaianForm.vue?vue&type=script&lang=js"
export * from "./MetodePenyampaianForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__